import $ from 'jquery';

import { $Elements, Breakpoints, Classes, Events } from './constants';
import { disableBodyScroll, enableBodyScroll, smoothScrollTo } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	$Elements.PageWrapper.on('click', '.menu-toggle, a[href="#menu-wrapper"], .menu-overlay', function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			$Elements.body.removeClass(Classes.menuOpen);
			enableBodyScroll();
			$('.header-menu-wrapper > .menu > .menu-item').removeClass(Classes.active);
		}
		else {
			$Elements.body.addClass(Classes.menuOpen);
			disableBodyScroll();
		}
	});

	if(window.innerWidth > Breakpoints.menu) {
		const menuItems = document.querySelectorAll('.menu-item');
		const subMenus = document.querySelectorAll('.submenu-wrapper');
		const headerMenu = document.querySelector('.header-menu-wrapper');
		const overlay = document.getElementById('page-wrapper');

		menuItems.forEach((item) => {
			item.addEventListener('click', (e) => {
				e.stopPropagation();

				const isOpen = item.classList.contains('item-active');

				menuItems.forEach((menuItem) => {
					menuItem.classList.remove('item-active');
				});

				if(!isOpen) {
					item.classList.add('item-active');
					overlay.classList.add('item-active');
					headerMenu.classList.add('item-active');
				}
				else {
					overlay.classList.remove('item-active');
					headerMenu.classList.remove('item-active');
				}
			});
		});

		subMenus.forEach((subMenu) => {
			subMenu.addEventListener('click', (e) => {
				e.stopPropagation();
			})
		})

		overlay.addEventListener('click', (e) => {
			e.stopPropagation();

			menuItems.forEach((menuItem) => {
				menuItem.classList.remove('item-active');
			});

			overlay.classList.remove('item-active');
		});
	}


	$Elements.PageWrapper.on('click', '.navbar-menu a, .menu-wrapper a', function(e) {

		const linkTarget = this.getAttribute('href');
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			e.preventDefault();

			const section = $(sectionTarget);

			if(section.length) {

				window.history.replaceState(null, null, sectionTarget);

				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll()
				smoothScrollTo(section);
			}
			else if(sectionTarget !== '#') {
				window.location = linkTarget;
			}
		}
	});

	// ----------- Menu mobile -------------

	$Elements.PageWrapper.on('click', '.header-menu-wrapper > .menu > .menu-item .submenu-btn', function(e) {
		if(window.innerWidth < Breakpoints.menu) {
			e.preventDefault();

			const nav = document.querySelector('.header-menu-wrapper');

			if(!nav.classList.contains('item-open')) {
				nav.classList.add('item-open');
			}
			else {
				nav.classList.remove('item-open');
			}

			if(!$(this).hasClass('close')) {
				$('.header-menu-wrapper > .menu > .menu-item').removeClass(Classes.active);
			}

			$(this).closest('.menu-item').toggleClass(Classes.active);
		}
	});
});
